export const redditColors = {
  orange: '#FF4500',
  darkText: '#1A1A1B',
  secondaryText: '#7C7C7C',
  border: '#EDEFF1',
  iconGray: '#878A8C',
  background: '#FFFFFF',
  urlBarBg: '#F6F7F8',
}
